module.exports = __webpack_public_path__ + "img/happiness.0c44c11a.png";